






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Card } from '../models/simple-war';

@Component({
  components: {},
})
export default class CardComponent extends Vue {
  @Prop() public card!: Card;
  @Prop() public isOnBoard!: boolean;
  @Prop() public username!: string;
  @Prop() public isSmall!: boolean;

  public cardClicked() {
    this.$emit('cardClickedEvent');
  }

  public determineClass() {
    if (this.isOnBoard) {
      if (this.card.owner === this.username) {
        return 'my-card';
      } else {
        return 'opponent-card';
      }
    } else {
      if (this.card.clicked) {
        return 'selected-card';
      } else {
        '';
      }
    }
  }
}
